export const SUPPLIERS_RESET_STATE = 'SUPPLIERS_RESET_STATE';
export const SUPPLIERS_CURRENT_ITEM = 'SUPPLIERS_CURRENT_ITEM';

export const SUPPLIERS_REQUEST_LOADING = 'SUPPLIERS_REQUEST_LOADING';
export const SUPPLIERS_REQUEST_SUCCESS = 'SUPPLIERS_REQUEST_SUCCESS';
export const SUPPLIERS_REQUEST_FAILED = 'SUPPLIERS_REQUEST_FAILED';

export const SUPPLIERS_CURRENT_ACTION = 'SUPPLIERS_CURRENT_ACTION';
export const SUPPLIERS_RESET_ACTION = 'SUPPLIERS_RESET_ACTION';
